export class RelColumn
{
  public UniqueID: number;
  public FieldID: string;
  public ContainerID: string;
  public ContainerUniqueID: number;
  public DatasourceID: string;
}
